import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import { StatCell } from "../stat-strip";

/** One cell of the analytics strip: this week's number and how it moved against last week. */
export function Kpi({
  label,
  value,
  prev,
  prevLabel,
  invert,
}: {
  label: string;
  value: number | string;
  prev?: number;
  prevLabel?: string;
  invert?: boolean;
}) {
  const numeric = typeof value === "number" && typeof prev === "number";
  const delta = numeric ? value - prev : 0;
  const good = invert ? delta < 0 : delta > 0;
  const moved = numeric && delta !== 0;
  return (
    <StatCell
      label={label}
      value={value}
      tone={moved ? (good ? "good" : "bad") : "neutral"}
      detail={
        moved ? (
          <span className="flex items-center gap-1">
            {delta > 0 ? <ArrowUpRight className="size-3" /> : <ArrowDownRight className="size-3" />}
            {delta > 0 ? "+" : ""}
            {delta} vs last week
          </span>
        ) : prevLabel !== undefined ? (
          <span className="flex items-center gap-1">
            <Minus className="size-3" /> last week {prevLabel}
          </span>
        ) : (
          "—"
        )
      }
    />
  );
}
